/* Shared blend-video controller:
   - fade at loop seam (no start/end frame jump)
   - pause when off-screen (huge perf win when 3+ videos exist)
   - lazy first-paint via preload=metadata
*/
(function () {
  const FADE = 0.55;

  function attachLoopFade(video) {
    if (!video || video.__spcAttached) return;
    video.__spcAttached = true;

    video.style.transition = 'opacity ' + FADE + 's ease-in-out';
    video.style.opacity = '0';

    let raf = null;
    function tick() {
      raf = null;
      const d = video.duration;
      const t = video.currentTime;
      if (!isFinite(d) || d <= 0) return;
      video.style.opacity = (t > d - FADE || t < FADE) ? '0' : '1';
    }
    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(tick);
    }
    video.addEventListener('loadedmetadata', schedule);
    video.addEventListener('timeupdate', schedule);
    video.addEventListener('seeked', schedule);
    video.addEventListener('play', schedule);
  }

  function attachVisibilityPause(video) {
    if (video.__spcVisAttached) return;
    video.__spcVisAttached = true;

    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          if (video.paused) video.play().catch(function () {});
        } else {
          if (!video.paused) video.pause();
        }
      });
    }, { threshold: 0.05 });
    io.observe(video);
  }

  function init() {
    const videos = document.querySelectorAll('.spc-blend-video');
    videos.forEach(function (v) {
      // Force light preload — only metadata, not the whole file
      if (v.getAttribute('preload') !== 'metadata') v.setAttribute('preload', 'metadata');
      // Hint to browser to keep on its own layer
      v.style.willChange = 'opacity';

      if (v.hasAttribute('data-loop-fade')) attachLoopFade(v);
      attachVisibilityPause(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
